import { useHealth } from '@/hooks/use-stats'
import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react'
import type { HealthStatus } from '@/api/stats'
import type { BadgeProps } from '@/components/ui/badge'

function getStatusIcon(status: HealthStatus['status']) {
  switch (status) {
    case 'healthy':
      return <CheckCircle className="h-4 w-4 text-green-500" />
    case 'degraded':
      return <AlertCircle className="h-4 w-4 text-yellow-500" />
    case 'down':
      return <XCircle className="h-4 w-4 text-red-500" />
  }
}

function getStatusVariant(status: HealthStatus['status']): BadgeProps['variant'] {
  switch (status) {
    case 'healthy':
      return 'success'
    case 'degraded':
      return 'warning'
    case 'down':
      return 'destructive'
  }
}

export function SystemHealth() {
  const { data: health, isLoading } = useHealth()

  return (
    <Card>
      <CardHeader>
        <CardTitle>System Health</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="text-muted-foreground">Checking...</div>
        ) : (
          <div className="space-y-3">
            {health?.map((service) => (
              <div
                key={service.service}
                className="flex items-center justify-between"
              >
                <div className="flex items-center gap-2">
                  {getStatusIcon(service.status)}
                  <span className="text-sm font-medium">{service.service}</span>
                </div>
                <Badge variant={getStatusVariant(service.status)}>
                  {service.status}
                </Badge>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
